import React, { useState, useEffect } from 'react';
import { postExpress } from '../../../service/api';
import md5 from 'md5';
import UserCreateMain from '../../presentation/section/admin-page/UserCreateMain';
import { USER_ROLE_SET } from '../../../config/UserRoleSet';

const leftPad = (value) => {
  if (value >= 10) {
    return value;
  }

  return `0${value}`;
}

const dateToString = (date, delimiter) => {
  const year = date.getFullYear();
  const month = leftPad(date.getMonth() + 1);
  const day = leftPad(date.getDate());

  return [year, month, day].join(delimiter); 
}

const toRoleSelectList = () => {
  let option = [];

  USER_ROLE_SET.forEach((item)=>{
    if(item.role == 'ROLE_USER'){

    }
    else{
      option.push({
        value: item.role,
        label: item.name,
      })
    }
  })

  return option;
}

const UserCreate = (props) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfimPassword] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState(USER_ROLE_SET[0].role);
  const [expireDate, setExpireDate] = useState(new Date());
  const [company, setCompany] = useState('');
  const [saveTooltip, setSaveTooltip] = useState('test')
  const [bio, setBio] = useState('');
  
  const roleSelectOption = toRoleSelectList();

  const selectRole = (e) => {
    if(e) {
      setRole(e.value);
    }
    else {
      setRole(null);
    }
  }

  const handleDate = (selectedDate) => {
    setExpireDate(selectedDate)
  }

  const handleCompany = (event) => {
    setCompany(event.target.value)
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
  }

  const handleConfirmPassword = (event) => {
    setConfimPassword(event.target.value)
  }

  const handleNewPassword = (event) => {
    setNewPassword(event.target.value);
  }

  const handleUsername = (event) => {
    setUsername(event.target.value)
  }

  const handleCreate = () => {
    const hashedNewPassword = md5(newPassword+"{"+email+"}");

    if(newPassword==confirmPassword && newPassword.length >= 8){
      postExpress('/account/signup', {
        bio: bio,
        email: email,
        username: username,
        password: hashedNewPassword,
        role: role,
        company: company,
        expireDate: dateToString(expireDate,'-'),
        macAddress: null
      }, (response) => {
        if (response.data.code == 3) {
          setSaveTooltip('중복된 E-mail이 존재합니다.')
        }
        else if (response.data.code == 0) {
          setEmail('');
          setUsername('');
          setNewPassword('');
          setConfimPassword('');
          setRole(USER_ROLE_SET[0].role);
          setCompany('');
          setExpireDate(new Date());
          setSaveTooltip('계정이 생성 완료 되었습니다.')
        }
      })
    }
    else if (newPassword!=confirmPassword) {
      setSaveTooltip('패스워드가 일치하지 않습니다.')
    }
    else if (newPassword.length < 8) {
      setSaveTooltip('패스워드가 8자 미만입니다.')
    }
  }

  return(
    <UserCreateMain handleCreate={handleCreate} handleDate={handleDate} expireDate={expireDate} saveTooltip={saveTooltip}
      company={company} handleCompany={handleCompany} email={email} handleEmail={handleEmail}
      confirmPassword={confirmPassword} handleConfirmPassword={handleConfirmPassword}
      newPassword={newPassword} handleNewPassword={handleNewPassword} username={username} handleUsername={handleUsername}
      roleSelectOption={roleSelectOption} defaultRole={roleSelectOption[0]} selectRole={selectRole}
    />
  )
}

export default UserCreate;
